import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

// reduxCreator.plugin(resetPlugin);


let redux = reduxCreator.type('FORUMS').plugin(axiosPlugin, {template: "array"});

let fetchForumsAction = redux.fetchActionGet();

export const TYPES = redux.types;
export const fetchForums = (query = {}) => fetchForumsAction(`/forums?${queryString.stringify(query)}`);
export const resetForums = () => redux.actions.reset();

export const forums = redux.reducer();